import {
  all,
  call,
  delay,
  fork,
  put,
  takeLatest,
  select,
} from 'redux-saga/effects';
import ApiConstants from 'src/common/helpers/ApiConstants';
import * as requests from 'src/common/helpers/HTTPRequest';
import { toastError, toastSuccess } from 'src/common/helpers/Notifications';
import TextConstants from 'src/common/helpers/TextConstants';
import {
  RECEIVERS_MANAGEMENT_ACTIONS,
  deleteReceiverCleanState,
  deleteReceiverError,
  deleteReceiverSuccess,
  getReceiversError,
  getReceiversSuccess,
} from './actions';

function* getReceiversSaga() {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.RECEIVERS_MANAGEMENT}`;
    const response = yield call(requests.getRequest, url, {});

    const { deviceAlarmSettings, isSnoozeExpired } = yield select(
      (state) => state.User
    );

    yield put(
      getReceiversSuccess({
        records: response,
        alarmSettings: { isSnoozeExpired, deviceAlarmSettings },
      })
    );
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(getReceiversError());
  }
}

function* deleteReceiverSaga({ payload: gatewayId, callback }) {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.GATEWAYS}/${gatewayId}`;
    yield call(requests.deleteRequest, url);
    yield put(deleteReceiverSuccess(gatewayId));
    toastSuccess(
      TextConstants.Common.DeletedSuccessMessage.replace(
        '{item}',
        TextConstants.Common.Receiver
      )
    );
    callback?.();
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(deleteReceiverError(e));
  } finally {
    yield delay(500);
    yield put(deleteReceiverCleanState());
  }
}

export function* ReceiversManagementSaga() {
  yield takeLatest(
    RECEIVERS_MANAGEMENT_ACTIONS.GET_RECEIVERS,
    getReceiversSaga
  );
  yield takeLatest(
    RECEIVERS_MANAGEMENT_ACTIONS.DELETE_RECEIVER,
    deleteReceiverSaga
  );
}

export default function* rootSaga() {
  yield all([fork(ReceiversManagementSaga)]);
}
